import { sanitizePaymentAmount } from "../util/sanitizePaymentAmount";

export default function paymentForm() {
    return {
        init() {
            this.$refs.paymentAmount?.addEventListener('input', (e) => {
                e.target.value = sanitizePaymentAmount(e.target.value);
            });
        },
    }
}
